// extracted by mini-css-extract-plugin
module.exports = {"container":"ri-z","list":"si-z"};